import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MenuSettings } from '../project-settings/project-settings.component';

export enum ConfigurationType {
  EVENT = 'EVENT',
  TASK = 'TASK',
  NOTIFICATION = 'NOTIFICATION',
  ISSUE = 'ISSUE',
  BUG_ORIGIN = 'BUG_ORIGIN',
  PRIORITY = 'PRIORITY',
  SEVERITY = 'SEVERITY',
  ARTIFACT = 'ARTIFACT',
  CURRENCY = 'CURRENCY',
}

@Injectable({
  providedIn: 'root'
})
export class ProjectSettingService {

  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {

  }

  // Configuration Languages
  getLanguages() {
    return this.http.get<any>(environment.API_URL + '/api/configurations/languages');
  }

  // Configuration
  createConfig(projectId: number, data: any) {
    return this.http.post<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, data, { headers: this.headers });
  }

  getAllConfig(projectId: number, page: number = 1, pageSize: number = 7, type?: string, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      page,
      pageSize,
      sort: 'id:ASC',
    });

    if (type && type !== '') {
      params = params.append('query[type]', type);
    }

    if (search) params = params.appendAll({
      searchFields: `name`,
      search
    });

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, { params });
  }

  getConfig(projectId: number, id: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations/${id}`);
  }

  getConfigByPage(pageSize: number, page: number, projectId: number, type: string, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'id:ASC',
      pageSize,
      page
    });

    if (type && type !== '') {
      switch (type) {
        case MenuSettings.Priority: {
          params = params.append('query[type]', ConfigurationType.PRIORITY);
          break;
        }
        case MenuSettings.Event: {
          params = params.append('query[type]', ConfigurationType.EVENT);
          params = params.append('query[type]', ConfigurationType.TASK);
          params = params.append('query[type]', ConfigurationType.NOTIFICATION);
          break;
        }
        case MenuSettings.Artifact: {
          params = params.append('query[type]', ConfigurationType.ARTIFACT);
          break;
        }
        case MenuSettings.Column: {
          break;
        }
        default: {
          params = params.append('query[type]', type);
          break;
        }
      }
    }
    
    if (type == MenuSettings.Column) {

      if (search && search !== '') {
        params = params.appendAll({
          searchFields: 'name,color',
          search
        });
      }
      return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns`, { params })
    } else {
      if (search && search !== '') {
        params = params.appendAll({
          searchFields: 'description,clientDescription',
          search
        });
      }

      return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, { params });
    }

  }

  getEventMeetingConfiguration(projectId: number) {
    let params = new HttpParams();
    params = params.appendAll({
      // 'query[type]': ConfigurationType.EVENT
      'query[isReunion]': true
    });

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, { params });
  }

  updateConfig(projectId: number, id: number, data: any) {
    return this.http.patch<any>(environment.API_URL + `/api/projects/${projectId}/configurations/${id}`, data, { headers: this.headers });
  }

  deleteConfig(projectId: number, id: number) {
    return this.http.delete(environment.API_URL + `/api/projects/${projectId}/configurations/${id}`);
  }
}
